import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../../Navbar/Navbar';
import {
    Box,
    Typography,
    CircularProgress,
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TextField,
    TablePagination,
} from '@mui/material';
import baseURL from '../../config';

const PendingFormI = () => {
    const [statuses, setStatuses] = useState([]);
    const [filteredStatuses, setFilteredStatuses] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
        const fetchStatuses = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`${baseURL}/api/getStatusWithoutForm1`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setStatuses(res.data.data);
                setFilteredStatuses(res.data.data);
            } catch (err) {
                setError(err.response?.data?.message || 'Something went wrong');
            } finally {
                setLoading(false);
            }
        };

        fetchStatuses();
    }, []);

    // Filter on search
    useEffect(() => {
        const term = searchTerm.toLowerCase();
        const filtered = statuses.filter((status) => {
            const crewName = status.contractId?.crewdetails?.name?.toLowerCase() || '';
            const indos = status.contractId?.crewdetails?.indosno?.toLowerCase() || '';
            const vessel = status.contractId?.vesselName?.toLowerCase() || '';
            return (
                crewName.includes(term) ||
                indos.includes(term) ||
                vessel.includes(term)
            );
        });
        setFilteredStatuses(filtered);
        setPage(0); // reset to first page on search
    }, [searchTerm, statuses]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <>
            <Navbar />
            <Container sx={{ mt: 4 }}>
                <Typography variant="h5" gutterBottom>
                    Pending Form I Contracts
                </Typography>

                <TextField
                    label="Search by Crew Name, Indos No., or Vessel"
                    variant="outlined"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ mb: 2 }}
                />

                {loading ? (
                    <CircularProgress />
                ) : error ? (
                    <Typography color="error">{error}</Typography>
                ) : filteredStatuses.length === 0 ? (
                    <Typography>No matching contracts found.</Typography>
                ) : (
                    <Paper>
                        <TableContainer>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#1976d2' }}>
                                    <TableRow>
                                        <TableCell sx={{ color: 'white' }}>Sr. No.</TableCell>
                                        <TableCell sx={{ color: 'white' }}>Vessel Owner</TableCell>
                                        <TableCell sx={{ color: 'white' }}>Crew</TableCell>
                                        <TableCell sx={{ color: 'white' }}>Crewing Agent</TableCell>
                                        <TableCell sx={{ color: 'white' }}>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredStatuses
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((status, index) => {
                                            const crew = status.contractId?.crewdetails;
                                            const agent = status.crewingAgentId;

                                            return (
                                                <TableRow key={index}>
                                                <TableCell>{page * rowsPerPage + index + 1}</TableCell>

                                                    {/* Vessel Owner Column */}
                                                    <TableCell>
                                                        <Typography><strong>Company:</strong> {status?.contractId?.vesselOwnerName}</Typography>
                                                        <Typography><strong>Vessel:</strong> {status?.contractId?.vesselName}</Typography>
                                                        <Typography>
                                                            <strong>Contract Created At:</strong>{' '}
                                                            {new Date(status.createdAt).toLocaleString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric',
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                second: '2-digit',
                                                            })}
                                                        </Typography>
                                                        <Typography><strong>Contract Created By:</strong> {status.contractId?.creatorIdWithName[0]?.name}</Typography>

                                                    </TableCell>

                                                    {/* Crew Column */}
                                                    <TableCell>
                                                        <Typography><strong>Name:</strong> {status.contractId?.crewdetails?.name}</Typography>
                                                        <Typography><strong>Indos No.:</strong> {status.contractId?.crewdetails?.indosno}</Typography>
                                                        <Typography><strong>Email:</strong> {status.contractId?.crewdetails?.email}</Typography>
                                                        <Typography><strong>Rank:</strong> {status.contractId?.crewdetails?.rankname}</Typography>

                                                    </TableCell>

                                                    {/* Crewing Agent Column */}
                                                    <TableCell>
                                                        {agent?.agentName}
                                                    </TableCell>

                                                    {/* Status Column */}
                                                    <TableCell>
                                                        <Typography><strong>Admin Status:</strong> {status.latestStatus?.adminStatus || 'N/A'}</Typography>
                                                        <Typography><strong>Crewing Agent Status:</strong> {status.latestStatus?.crewingAgentStatus || 'N/A'}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={filteredStatuses.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[5, 10, 25]}
                        />
                    </Paper>
                )}
            </Container>
        </>
    );
};

export default PendingFormI;
